export default "__VITE_ASSET__a2092779__"